import SliderIconWrapper from './SliderIconWrapper';

export default SliderIconWrapper;



// WEBPACK FOOTER //
// ./src/components/pages/VehiclePage/components/SliderIconWrapper/index.js